<template>
  <div >
    <div style="height: 36px;margin-bottom: 10px">
      <el-button type="primary" @click="handleInfo2" size="medium" style="font-size: 12px;">添加配置</el-button>
    </div>
    <!-- 表格部分 -->
    <el-table :data="loanTable" size="mini" border style="width: 100%" v-loading="loading">
      <!-- id -->
      <el-table-column
          header-align="center"
          align="center"
          fixed
          prop="id"
          label="ID"
          min-width="80"
      ></el-table-column>
      <!-- 名称 -->
      <el-table-column
          header-align="center"
          align="center"
          prop="config_name"
          label="名称"
          min-width="120"
      ></el-table-column>
      <!-- 键 -->
      <el-table-column
          header-align="center"
          align="center"
          prop="config_key"
          label="键"
          min-width="120"
      ></el-table-column>
      <!-- 值 -->
      <el-table-column
          header-align="center"
          align="center"
          prop="config_value"
          label="值"
          min-width="120"
      ></el-table-column>
      <!-- 描述 -->
      <el-table-column
          header-align="center"
          align="center"
          prop="remark"
          label="描述"
          min-width="120"
      ></el-table-column>
      <!-- 修改人 -->
      <el-table-column
          header-align="center"
          align="center"
          prop="modifier"
          label="修改人"
          min-width="120"
      ></el-table-column>
      <!-- 修改时间 -->
      <el-table-column
          header-align="center"
          align="center"
          prop="modify_time"
          label="修改时间"
          min-width="120"
      ></el-table-column>
      <!-- 操作 -->
      <el-table-column
          header-align="center"
          align="center"
          label="操作"
          min-width="120"
      >
        <template slot-scope="scope">
          <el-button type="text" @click="handleInfo(scope.row)">编辑</el-button>

        </template>
      </el-table-column>
    </el-table>

    <el-dialog v-if="dialogVisible" title="配置表单" :visible.sync="dialogVisible">
      <el-form :model="dialogData" :rules="rules" ref="ruleForm">
        <el-form-item label="名称" :label-width="formLabelWidth" prop="config_name" style="margin-bottom: 17px">
          <el-input v-model="dialogData.config_name" autocomplete="off" placeholder="请输入配置名称"
                    style="width: 400px"></el-input>
        </el-form-item>
        <el-form-item label="键" :label-width="formLabelWidth" prop="config_key" style="margin-bottom: 17px">
          <el-input v-model="dialogData.config_key" autocomplete="off" :disabled="disabled1" placeholder="请输入键"
                    style="width: 400px"></el-input>
        </el-form-item>
        <el-form-item label="值" :label-width="formLabelWidth" prop="config_value" style="margin-bottom: 17px">
          <el-input v-model="dialogData.config_value" autocomplete="off" type="textarea" placeholder="请输入值"
                    style="width: 400px"></el-input>
        </el-form-item>
        <el-form-item label="描述" :label-width="formLabelWidth" style="margin-bottom: 17px">
          <el-input v-model="dialogData.remark" autocomplete="off" type="textarea" placeholder="请输入描述"
                    style="width: 400px"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitForm('ruleForm')">确 定</el-button>
      </div>
    </el-dialog>
  </div>


</template>

<script>
export default {
  name: "index",
  data() {
    return {
      loanTable: [], //列表
      loading: true, //列表loadding
      dialogVisible: false,//编辑表单页面显示
      formLabelWidth: '120px',
      disabled1: true,//键禁用
      dialogData: {},//编辑表单页面显示数据
      rules: {
        config_name: [
          {required: true, message: '请输入配置名称', trigger: 'blur'},
        ],
        config_key: [
          {required: true, message: '请输入键', trigger: 'blur'}
        ],
        config_value: [
          {required: true, message: '请输入值', trigger: 'blur'}
        ]
      }
    }
  },
  mounted() {
    this.getData();
  },
  methods: {
    // 编辑表单显示
    handleInfo(row) {
      this.dialogData = JSON.parse(JSON.stringify(row))
      this.dialogVisible = true;
      this.disabled1 = true;
    },
    handleInfo2() {
      this.dialogData = {};
      this.dialogVisible = true;
      this.disabled1 = false;
    },
    // 页面显示
    getData() {
      this.$api.post("/api/system/configList", {}, res => {
        this.loanTable = res.data;
        //渲染结束后取消加载
        this.loading = false;
      })
    },
    // 编辑表单校验
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          // 编辑确定
          this.$api.post("/api/system/configSave", this.dialogData, res => {
            if (res.status == 200) {
              this.$message({
                type: 'success',
                message: '操作成功',
                duration: 1000,
                onClose() {
                }
              });
              this.dialogVisible = false;
              this.getData();
            } else {
              this.$message.error(res.msg);
            }
          })
        } else {
          return false;
        }
      });
    },
  }
}
</script>

<style scoped>

</style>
